import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/bg-qr-code-hub.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a4e95032")

_pushScopeId("data-v-a4e95032")
const _hoisted_1 = {
  id: "qr-code-hub",
  style: {"display":"none"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"width":"100%"},
  alt: "qrcode"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("canvas", {
  id: "qr-code-hub-canvas",
  class: "absolute",
  style: {"top":"560px","left":"320px"}
}, null, -1)
const _hoisted_4 = {
  class: "absolute flex flex-col justify-center text-center text-white font-semibold",
  style: {"top":"1265px","left":"320px","width":"620px","height":"120px","font-size":"32px"}
}
const _hoisted_5 = { class: "w-full uppercase" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = {
  class: "absolute",
  style: {"bottom":"231px","width":"100%","padding-left":"200px","padding-right":"200px","text-align":"center","font-size":"29px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.ellipsisString(_ctx.partnerName)), 1),
      _createVNode("span", _hoisted_6, "ID " + _toDisplayString(_ctx.partnerId), 1)
    ]),
    _createVNode("div", _hoisted_7, _toDisplayString(_ctx.partnerAddress), 1)
  ]))
})